module.exports = __webpack_public_path__ + "static/media/creditcard-general.93233481.png";